import { post } from 'core/helpers/fetch';
import {
  CREATE_TABOO_INSTANCE_STARTED,
  CREATE_TABOO_INSTANCE_SUCCEED,
  CREATE_TABOO_INSTANCE_FAILED,
} from 'app/games/taboo/reducers/instances';

function createInstance() {
  return async dispatch => {
    dispatch({ type: CREATE_TABOO_INSTANCE_STARTED });
    try {
      const createdInstance = await dispatch(post('/games/taboo/instances'));
      dispatch({ type: CREATE_TABOO_INSTANCE_SUCCEED, payload: { instance: createdInstance } });
      return createdInstance;
    } catch (exception) {
      dispatch({ type: CREATE_TABOO_INSTANCE_FAILED, payload: { exception } });
      throw exception;
    }
  };
}

export default createInstance;
